<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-4.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Reports</span>
</div>
<div *ngIf="showingDashboard" class="reports-dashboard">
  <div class="daily-reports">
    <div class="daily-title card">Daily</div>
    <div class="reports-container">
      <button
        (click)="selectReport(report)"
        class="report card"
        *ngFor="let report of dailyReports"
      >
        {{ report.name }}
      </button>
      <button
        *ngIf="isAdmin"
        (click)="showingDownloadData = true; showingDashboard = false"
        class="report card"
      >
        Download Data
      </button>
    </div>
  </div>
  <div class="annual-reports">
    <div class="annual-title card">Annual</div>
    <div class="reports-container">
      <button
        class="report card"
        (click)="selectReport(report)"
        *ngFor="let report of annualReports"
      >
        {{ report.name }}
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="!showingDashboard && !showingDownloadData"
  class="request-report-form"
>
  <span class="report-title">{{ title }} Report</span>
  <app-dropdown
    *ngIf="showingYear"
    label="Year"
    [options]="years"
    key="name"
    (selectedDropdownItem)="selectedYear = $event"
  ></app-dropdown>
  <app-dropdown
    *ngIf="showingBases"
    label="{{getBaseLabel()}}"
    [options]="bases"
    key="text"
    (selectedDropdownItem)="selectBase($event)"
  ></app-dropdown>
  <app-dropdown
    *ngIf="showingStatus"
    [(choice)]="selectedStatus"
    label="Status"
    [options]="status"
    key="value"
    (selectedDropdownItem)="selectStatus($event)"
  ></app-dropdown>
  <app-dropdown
    *ngIf="showingChutes"
    [(choice)]="selectedChuteStyle"
    label="Parachute Type"
    [options]="[
      {
        name: 'Main',
        value: 'Main',
        chutetype: 1
      },
      {
        name: 'Drogue',
        value: 'Drogue',
        chutetype: 3
      },
      {
        name: 'Reserve',
        value: 'Reserve',
        chutetype: 2
      }
    ]"
    key="name"
    (selectedDropdownItem)="selectedChuteStyle = $event"
  ></app-dropdown>
  <app-combobox
    [(choice)]="selectedChute"
    *ngIf="showingChutes && selectedChuteStyle.value === 'Main'"
    label="Parachute Name"
    [options]="mainChutes"
    key="name"
    (selectedComboboxItem)="selectedChute = $event"
  ></app-combobox>
  <app-combobox
    [(choice)]="selectedChute"
    *ngIf="showingChutes && selectedChuteStyle.value === 'Drogue'"
    label="Parachute Name"
    [options]="drogueChutes"
    key="name"
    (selectedComboboxItem)="selectedChute = $event"
  ></app-combobox>
  <app-combobox
    [(choice)]="selectedChute"
    *ngIf="showingChutes && selectedChuteStyle.value === 'Reserve'"
    label="Parachute Name"
    [options]="reserveChutes"
    key="name"
    (selectedComboboxItem)="selectedChute = $event"
  ></app-combobox>
  <div
    *ngIf="showingAllJumpers && selectedBase.id !== ''"
    class="jumpers-container"
  >
    <div class="jumper datum" *ngFor="let jumper of jumpers; index as i">
      <div class="checkbox-container">
        <input
          aria-label="Select Jumper"
          type="checkbox"
          [(ngModel)]="jumper.checked"
          [name]="jumper.name"
        />
        <span class="ldo-jumper-name">{{ jumper.friendly }}</span>
      </div>
    </div>
  </div>
  <app-dropdown
    *ngIf="showingJumpers"
    label="Jumper"
    [options]="jumpers"
    key="fullName"
    (selectedDropdownItem)="selectedJumper = $event"
  ></app-dropdown>
  <app-dropdown
    *ngIf="showingSpotters"
    label="Spotter"
    [options]="spotters"
    key="friendly"
    (selectedDropdownItem)="selectedJumper = $event"
  ></app-dropdown>
  <app-dropdown
    *ngIf="showingQualifications"
    label="Qualifications"
    [options]="qualifications"
    key="title"
    (selectedDropdownItem)="selectedQualification = $event"
  ></app-dropdown>
  <app-dropdown
    label="File Type"
    [options]="fileTypes"
    key="name"
    (selectedDropdownItem)="selectedFileType = $event"
  ></app-dropdown>
  <div class="buttons">
    <app-button
      [disabled]="isDisabled()"
      class="generate-report-button"
      text="Generate Report"
      (clicked)="generateReport()"
    ></app-button>
    <app-button
      class="return-to-dashboard-button"
      text="Return to Reports"
      (clicked)="goToDash()"
    ></app-button>
  </div>
</div>
<div *ngIf="showingDownloadData && !loading" class="request-report-form">
  <app-dropdown
    label="Calendar Year"
    [options]="years"
    key="value"
    (selectedDropdownItem)="selectedYear = $event"
  ></app-dropdown>
  <app-dropdown
    label="Type of Data"
    [options]="[
      {
        name: 'Incident Info',
        value: 'Incident Info'
      },
      {
        name: 'Incident Jumper',
        value: 'Incident Jumper'
      }
    ]"
    key="value"
    (selectedDropdownItem)="selectedFileType = $event"
  ></app-dropdown>
  <a id="download">-</a>
  <div class="buttons">
    <app-button
      class="generate-report-button"
      text="Download Data"
      (clicked)="downloadData()"
    ></app-button>
    <app-button
      class="return-to-dashboard-button"
      text="Return to Reports"
      (clicked)="goToDash()"
    ></app-button>
  </div>
</div>
<div *ngIf="showingDownloadData && loading" class="request-report-form">
  <p>Please wait while while the Incident data is being processed...</p>
</div>
